var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    {
      staticClass: "no-border",
      attrs: { id: "select-format", "no-label": "" },
    },
    [
      _c("v-select-field", {
        staticClass: "search-input w-100 simple-dd",
        attrs: {
          options: _vm.formatOptions,
          placeholder: _vm.$t("global.actions.chooseOption"),
          value: _vm.localSelectedFormat,
          clearable: false,
          label: "text",
          "default-value": _vm.localSelectedFormat,
          multiple: _vm.multiple,
        },
        on: { "option:selected": _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }